/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "BrandingAPI",
            "endpoint": "https://u9daf3q44d.execute-api.us-east-2.amazonaws.com/staging",
            "region": "us-east-2"
        },
        {
            "name": "EnvironmentsAPI",
            "endpoint": "https://5l82pbobz0.execute-api.us-east-2.amazonaws.com/staging",
            "region": "us-east-2"
        },
        {
            "name": "IcebergCyberAPI",
            "endpoint": "https://il4g5hhf18.execute-api.us-east-2.amazonaws.com/staging",
            "region": "us-east-2"
        },
        {
            "name": "MailchimpAPI",
            "endpoint": "https://uly4r284g4.execute-api.us-east-2.amazonaws.com/staging",
            "region": "us-east-2"
        },
        {
            "name": "PortAPI",
            "endpoint": "https://xlyt78aofd.execute-api.us-east-2.amazonaws.com/staging",
            "region": "us-east-2"
        },
        {
            "name": "ScoreClaimAPI",
            "endpoint": "https://gky4qi374l.execute-api.us-east-2.amazonaws.com/staging",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:0c9281a6-b536-41d8-a4aa-e58245376e34",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_A18VNVG7n",
    "aws_user_pools_web_client_id": "2ffe17a6ndmq4lrqvf7p7cs3cu",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Branding-staging",
            "region": "us-east-2"
        },
        {
            "tableName": "PortMapping-staging",
            "region": "us-east-2"
        },
        {
            "tableName": "ScoreClaim-staging",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
